// app/client.tsx
import { StartClient } from "@tanstack/react-start"
import { StrictMode } from "react"
import { hydrateRoot } from "react-dom/client"
import { getClientRootContext } from "./contexts/root-context/getClientRootContext"
import { createRouter } from "./router"

const router = createRouter(getClientRootContext())

hydrateRoot(
  document,
  <StrictMode>
    <StartClient router={router} />
  </StrictMode>,
)
